export function createIdTextValIndexArr(data) {
  return data.map((item, index) => ({
    id: index,
    text: item,
    val: item,
  }));
}
